/**
 * Rich Text Editor Component
 *
 * Wraps react-quill-new for editing HTML email templates.
 * Styled to blend with Polaris UI.
 */

import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { Text, BlockStack } from '@shopify/polaris';

const MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
};

const FORMATS = [
  'header',
  'bold', 'italic', 'underline',
  'color', 'background',
  'list',
  'link',
];

interface RichTextEditorProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
}

export default function RichTextEditor({ label, value, onChange }: RichTextEditorProps) {
  return (
    <BlockStack gap="100">
      <Text as="span" variant="bodyMd">
        {label}
      </Text>
      <div className="rich-text-editor-wrapper">
        <style>{`
          .rich-text-editor-wrapper .ql-container {
            min-height: 150px;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            font-size: 14px;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
          }
          .rich-text-editor-wrapper .ql-toolbar {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            background: #f6f6f7;
          }
          .rich-text-editor-wrapper .ql-editor {
            min-height: 150px;
          }
        `}</style>
        <ReactQuill
          theme="snow"
          value={value}
          onChange={onChange}
          modules={MODULES}
          formats={FORMATS}
        />
      </div>
    </BlockStack>
  );
}
